<template>
  <v-main v-if="shop">
<!--    TODO add share functionality to shop page, and user profile page-->
    <!--    TODO add a 'Do you have employees/Does anyone else work here' button, and let users invite other users and add them to the store's employees-->
    <head>
      <title>{{shop.name}}</title>
      <meta v-if="shop.description" name="description" :content="shop.description.substring(0,255)">
      <meta v-else name="description" :content="shop.name + ', a shop on Foraje, located at '+ shop.address">
    </head>
    <v-alert color="warning" icon="mdi-alert"
             transition="scale-transition" style="z-index: 1" prominent v-if="!shop_loading" v-show="!shop.approved" dark>This Shop has not been approved. If you just created it, give us time to check it out. If there's a problem with it, we'll reach out.</v-alert>
    <v-container v-if="shop_loading">
      <v-row  >
        <v-col cols="12" class="text-center">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else-if="!shop_loading">
      <v-dialog v-model="claimshopdialog"
                max-width="750"
      >
        <v-card>
          <v-card-title
            class="headline"
            primary-title
            style="justify-content: center"
          >
            Claim ' {{shop.name}} '
          </v-card-title>
          <v-card-text>
            Are you the owner of '{{shop.name}}'? If so, click 'Submit Claim', and we'll go ahead and give ownership and control of this shop to you. It might take us up to a day to get it all switched over.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              dark
              @click="claimshopdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="claimsubmitloading"
              :disabled="claimsubmitloading"
              @click="SubmitClaim"
              dark
            >
              Submit Claim
              <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="signup_claimshopdialog"
                max-width="750"
      >
        <form @submit.prevent="SignupAndSubmitClaim">
          <v-alert dismissible color="error" icon="mdi-alert-outline" v-model="termsalert" style="margin-bottom: 2px" dark>If you would like to create an account on Foraje, you must accept and agree to the terms and conditions, content policy, and privacy policy</v-alert>

          <v-card>
          <v-card-title
            class="headline"
            primary-title
            style="justify-content: center"
          >
            Sign up, and claim ' {{shop.name}} '
          </v-card-title>
          <v-card-text>

            <v-text-field
              name="email"
              label="Email"
              id="email"
              v-model="email"
              type="email"
              hint="A real email, since you'll need to verify it. This will let you log in to edit your shop, list your products, etc."

              required/>
            <v-text-field
              name="password"
              label="Password"
              id="password"
              v-model="password"
              :type="password_show ? 'text' : 'password'"
              hint="At least 8 characters, up to 255, no special requirements just please don't use common words/passwords."
              min="8"
              :counter="255"
              required
              :append-icon="password_show ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="password_show = !password_show"

            />
            <v-checkbox
              color="green"
              v-model="termscheckbox"
            >
              <label slot="label">
                Check here to indicate you have read and agree to the <router-link @click.stop to="/policies/terms">terms and conditions,</router-link> the <router-link @click.stop to="/policies/content">content policy</router-link> and the <router-link @click.stop to="/policies/privacy">privacy policy</router-link>
              </label>
            </v-checkbox>
            <v-checkbox
              color="green"
              v-model="emailcheckbox"
              label="Check here if you would like to receive email updates and newsletters"
            >
            </v-checkbox>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              dark
              @click="claimshopdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="signup_claimshoploading"
              :disabled="signup_claimshoploading"
              type="submit"
              dark
            >
              Submit Claim
              <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
            </v-btn>
          </v-card-actions>
        </v-card>
        </form>
      </v-dialog>
    <v-row>
      <v-col cols="12" md="8" class="mx-auto">
        <v-card class="fill-height">
          <v-card-title class="headline" style="justify-content: center">
            <span>
            {{shop.name}}
            </span>
          </v-card-title>
          <div style="justify-content: center" class="pa-5">
            {{shop.description}}
          </div>
          <v-subheader>
            <v-icon>mdi-map-marker</v-icon>{{shop.address}}
          </v-subheader>
          <v-subheader v-if="shop.external_page">
            <a :href="shop.external_page">
            <v-icon>mdi-web</v-icon>{{shop.external_page}}
            </a>
          </v-subheader>
          <!--<v-subheader style="justify-content: right">
                <v-card flat>
                  <v-avatar>
                    <v-img
                      :src="shop.owner.profile_image.image.medium_square_crop"
                      :lazy-src="shop.owner.profile_image.image.small_square_crop"
                      class="elevation-1 ProfilePicture"
                      v-if="shop.owner.profile_image && shop.owner.profile_image.image"
                    >
                    </v-img>
                    <v-img v-else src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" class="ProfilePicture elevation-1">
                    </v-img>
                  </v-avatar>
                  <router-link :to="'/profiles/'+ shop.owner.slug">{{shop.owner.display_name}}</router-link>
                </v-card>

          </v-subheader>-->
          <v-col cols="12" md="8" class="mx-auto">
          <v-card>
          <v-subheader v-if="cleaned_hours" @click="showfullhours = !showfullhours">
            <div v-for="(hour,index) in cleaned_hours" :key="index">
              <b v-if="hour.weekday_display === todayIs">
                <span v-if="hour.open_time[0]">Today's Hours:</span>
                <span v-for="(opentime, index) in hour.open_time" :key="index">
                  <span v-if="opentime && opentime.length">
                    {{opentime}} - {{hour.close_time[index]}} <span v-if="index + 1 < hour.open_time.length">, </span>
                    </span>
                    <span v-else>Closed Today</span>
                  </span>
              </b>
              <b v-else-if="hour.weekday_display === todayIs">Closed Today</b>
            </div>
              <v-btn text icon>
                <v-icon v-if="!showfullhours">mdi-menu-down</v-icon>
                <v-icon v-if="showfullhours">mdi-menu-up</v-icon>
              </v-btn>
          </v-subheader>
          <v-subheader v-else>
            Shop Hours Unknown
          </v-subheader>
          <v-card-text v-if="cleaned_hours && showfullhours">
            <div v-for="(hour,index) in cleaned_hours" :key="index">
                <b v-if="hour.weekday_display === todayIs">{{hour.weekday_display}} : <span v-for="(opentime, index) in hour.open_time" :key="index">
                  <span v-if="opentime && opentime.length">{{opentime}} - {{hour.close_time[index]}} <span v-if="index + 1 < hour.open_time.length">,</span></span>
                  <span v-else>Closed</span>
                </span>
                </b>
                  <span v-else>{{hour.weekday_display}} : <span v-for="(opentime, index) in hour.open_time" :key="index">
                    <span v-if="opentime && opentime.length"> {{opentime}} - {{hour.close_time[index]}}<span v-if="index + 1 < hour.open_time.length">, </span> </span>
                    <span v-else>Closed</span>
                  </span>
                  </span>
            </div>
          </v-card-text>
          </v-card>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="10" class="mx-auto">
        <v-card>
          <v-card-title style="justify-content: center">
            Currently Selling
          </v-card-title>
          <v-card-text v-if="list">
            <!--<ul v-for="(product, index) in shop.products" :key="index">
              <li>{{product.details.name}}</li>
              <span>${{product.details.price.slice(0, -2)}} per {{product.details.price_units}}</span>
              <br>
              <span>{{product.inventory}} remaining</span>
            </ul>-->
            <v-row v-for="(product, index) in shop.products" :key="index">
              <v-col cols="6">
                {{product.name}}
              </v-col>
              <v-col cols="6">
                ${{product.price.slice(0, -2)}} per {{product.price_units}}
                <p>{{product.inventory}} remaining</p>
              </v-col>
              <v-col cols="12"><v-divider/></v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-if="!list">
            <v-row v-for="(product, index) in shop.products" :key="index">
              <v-col cols="4">
                <v-card>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
    <v-col>
      <v-subheader style="justify-content: right" v-if="shop.owner.slug !='some-person'">
    <v-card flat>
      Shop owned by:
      <v-avatar>
        <v-img
          :src="shop.owner.profile_image.image.medium_square_crop"
          :lazy-src="shop.owner.profile_image.image.small_square_crop"
          class="elevation-1 ProfilePicture"
          v-if="shop.owner.profile_image && shop.owner.profile_image.image"
        >
        </v-img>
        <v-img v-else src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" class="ProfilePicture elevation-1">
        </v-img>
      </v-avatar>
      <router-link :to="'/profiles/'+ shop.owner.slug">{{shop.owner.display_name}}</router-link>
    </v-card>
      </v-subheader>
      <v-subheader v-else style="justify-content: right">Unknown Owner. Is this your business?
        <v-btn color="primary" class="ml-3" v-if="claim_submitted" disabled>Claim submitted.</v-btn>
        <v-btn color="primary" class="ml-3" @click="DialogSelection" v-else>Claim it now.</v-btn>

      </v-subheader>
    </v-col>
    </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios';

import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    termscheckbox: { required },
  },
  name: 'Shop',
  data: () => ({

    shop: [],
    shop_images: [],
    errors: [],
    shop_loading: false,
    shop_hours: [],
    cleaned_hours: [],
    showfullhours: false,
    list: true,
    claimshopdialog: false,
    claimsubmitloading: false,
    signup_claimshopdialog: false,
    signup_claimshoploading: false,
    email: '',
    password: '',
    password_show: false,
    // confirmPassword: '',
    signupalert: false,
    termsalert: false,
    termscheckbox: false,
    emailcheckbox: false,
    usertoken: '',
    claim_submitted: false,


  }),

  methods: {
    FetchShopInfo() {
      const shopSlug = this.$route.params.slug;
      this.shop_loading = true;
      axios.get(`shops/${shopSlug}/`)
        .then((response) => {
          this.shop = response.data;
          this.cleaned_hours = this.cleanHours(this.shop.hours);
          this.shop_loading = false;
          return axios.get(`/image/by/shop/${this.shop.id}/`);
        })
        .then((response) => {
          this.shop_images = response.data.results;
        })
        .then(() => {
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // takes the shop hours (typically taken from the backend), then takes out the duplicate days, and adds their times onto the matching days. ie instead of tuesday 1-5, tuesday 6-9, you get tuesday 1-5, 6-9
    cleanHours(array) {
      const output = array.reduce((o, cur) => {
        let newO = o;
        // Get the index of the key-value pair.
        const occurs = o.reduce((n, item, i) => ((item.weekday === cur.weekday) ? i : n), -1);

        // If the name is found,
        if (occurs >= 0) {
          // append the current value to its list of values.
          newO[occurs].open_time = newO[occurs].open_time.concat(cur.open_time);
          newO[occurs].close_time = newO[occurs].close_time.concat(cur.close_time);

          // Otherwise,
        } else {
          // add the current item to o (but make sure the value is an array).
          const obj = {
            weekday: cur.weekday,
            weekday_display: cur.weekday_display,
            open_time: [cur.open_time],
            close_time: [cur.close_time],
          };
          newO = newO.concat([obj]);
        }

        return newO;
      }, []);

      return output;
    },
    DialogSelection() {
      if (this.$store.getters.token) {
        this.claimshopdialog = true;
      } else { this.signup_claimshopdialog = true; }
    },
    SubmitClaim() {
      const authheader = `Token ${this.$store.getters.token}`;
      axios.post('forms/products/shops/claim/', { shop: this.shop.slug }, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.claimsubmitloading = false;
          this.claimshopdialog = false;
          this.claim_submitted = true;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Claim submitted! Once it\'s approved your shop will appear in your \'My Shops\' page.',
            alert_model: true,
          });
        })
        .catch((error) => {
          // this regex fix is stilllll pretty hacky, but it seems to work now.
          const regex = /\[(.*?)\]/;
          this.signupalert = false;
          this.erroralert = true;
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline',
            alert_color: 'error',
            alert_message: `Our system says: ${regex.exec(error.response.request.response)[1].replace(/['"]+/g, '')}`,
            alert_model: true,
          });
        });
    },
    SignupAndSubmitClaim() {
      if (this.termscheckbox === true) {
        this.signup_claimshoploading = true;
        axios.post('user/registration/', {
          email: this.email,
          password1: this.password,
          password2: this.password,
        })
          .then((response) => {
            this.usertoken = response.data.key;
          })
          .then(() => {
            if (this.emailcheckbox === true) {
              axios.post('mailinglist/subscribe/', {
                email: this.email,
                email_consent: this.emailcheckbox,
              });
            }
          })
          .then(() => {
            const authheader = `Token ${this.usertoken}`;
            axios.post('forms/products/shops/claim/', { shop: this.shop.slug }, {
              headers: {
                Authorization: authheader,
              },
            });
          })
          .then(() => {
            this.claim_submitted = true;
            this.signup_claimshoploading = false;
            this.signup_claimshopdialog = false;
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-check-circle',
              alert_color: 'success',
              alert_message: 'Claim submitted! Once it\'s approved your shop will appear in your \'My Shops\' page. Once you\'ve confirmed your email, you can sign in and edit it.',
              alert_model: true,
            });
          })
          .then(() => {
            this.$router.push('/sign_in');
          })
          .catch((error) => {
            // this regex fix is stilllll pretty hacky, but it seems to work now.
            const regex = /\[(.*?)\]/;
            this.signupalert = false;
            this.erroralert = true;
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: `Our system says: ${regex.exec(error.response.request.response)[1].replace(/['"]+/g, '')}`,
              alert_model: true,
            });
          });
      } else { this.termsalert = true; }
    },
  },

  created() {
    this.FetchShopInfo();
  },
  computed: {
    todayIs() {
      const date = new Date();
      return date.toLocaleDateString((window.navigator.language), { weekday: 'long' });
    },
  },

};
</script>

<style scoped>
  .FetchedThumbail{
    border-radius: 50%;
  }
  .ProfilePicture{
    border-radius: 50%;
  }
</style>
